<span class="action-toolbar">
  @if (!conceptsContainer.conceptType.cannot_add_new) {
    <button
      class="admin-stroked-button"
      type="button"
      mat-stroked-button
      color="primary"
      (click)="addConcept()"
    >
     <mat-icon>
       add
     </mat-icon>
      <span class="bold uppercase admin-stroked-button__left-margin">
        {{ 'TRANS__ADMIN__ADD_NEW' | translate }}
      </span>
  </button>
  }

  @if (conceptsContainer.conceptType.search_kulturnav) {
    <ng-container>
      <button
        class="admin-stroked-button"
        type="button"
        mat-stroked-button
        color="primary"
        (click)="getConceptsFromKulturNav()"
      >
        <mat-icon>
          get_app
        </mat-icon>
        <span class="bold uppercase">
          {{ 'TRANS__FIELD_SELECT__GET_FROM_AUTHORITY' | translate }}
        </span>
      </button>
  </ng-container>
  }
</span>
